<template>
  <div
    class="404View a-cover overflow-hidden flex-c text-center"
    :class="pageColorClasses"
  >
    <div class="relative w-full max-h-full overflow-auto scrolling-touch">
      <div class="relative w-full max-w-200 mx-auto my-8 px-4 flex justify-center items-center flex-col overflow-hidden">
        <div class="max-h-full overflow-hidden mb-6">
          <LogoLink :color="logoColor" />
        </div>
        <!-- 404 -->
        <span
          class="mb-4 last:mb-0 block text-7xl font-heading-bold leading-none uppercase select-none pointer-events-none"
          aria-hidden="true"
          v-html="'404'"
        />
        <!-- Heading -->
        <Heading
          class="mb-4 last:mb-0"
          :text="headingText"
          large
        />
        <!-- Text -->
        <div class="tiny-mce mb-4 last:mb-0">
          <p v-html="bodyText" />
        </div>
        <!-- Links -->
        <ol
          v-if="usedArr( menuButtonList )"
          class="flex-c flex-wrap"
        >
          <li
            v-for="(linkObj, i1) in menuButtonList"
            :key="`not-found-li-${i1 + 1}`"
            class="m-1"
          >
            <!-- Main -->
            <MultiBtn
              class="justify-center"
              :routeTo="linkObj.main.routeTo"
              :text="linkObj.main.btn_text || linkObj.main.title"
              :label="linkObj.main.title"
              :theme="buttonTheme"
              icon="arrow-right"
            />
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import LogoLink from '@/components/buttons/LogoLink.vue'
import Heading from '@/components/text/Heading.vue'
import MultiBtn from '@/components/buttons/MultiBtn.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Page404',

  components: {
    LogoLink,
    Heading,
    MultiBtn,
  },

  data() {
    return {
      pageTitle: '404 - Not found',
      heading: 'Sorry, page not found!',
      bodyCopy: 'Visit one of the below pages',
    }
  },

  computed: {
    // Data
    ...mapGetters([
      'myStore',
      'menuButtonList',
    ]),
    pageLabels() { return this.myStore(['labels', 'not_found_screen']) ?? {} },
    pageStyles() { return this.myStore(['styles', 'not_found_screen']) ?? {} },
    //
    pageColorClasses() {
      const { pageStyles } = this
      const { bg_color, text_color } = pageStyles
      // Background
      const bgColorClass = `bg-${bg_color || 'bg-off-white'}`
      // Text
      const textColorClass = `text-${text_color || 'text-body'}`
      // Return
      return [
        bgColorClass,
        textColorClass,
      ]
    },
    pageTitleText() {
      const { pageTitle, pageLabels } = this
      const { page_title } = pageLabels
      return page_title || pageTitle
    },
    // Logo
    logoColor() {
      const { pageStyles } = this
      const { logo_slug } = pageStyles
      return logo_slug || 'color'
    },
    // Heading
    headingText() {
      const { heading, pageLabels } = this
      const { heading_text } = pageLabels
      return heading_text || heading
    },
    // Body
    bodyText() {
      const { bodyCopy, pageLabels } = this
      const { body } = pageLabels
      return body || bodyCopy
    },
    // Buttons
    buttonTheme() {
      const { pageStyles } = this
      const { button_style } = pageStyles
      return button_style || 'button_style_1'
    },
  },

  created() {
    const { pageTitleText } = this
    this.$store.commit('pageMeta', { pageTitleText })
  },

  mounted() {
  },
}
</script>
